<div class="container-fluid">
    <div class="row" *ngIf="modoEdicion">
        <div class="col-12 p-3 text-right" style="text-align: right;">
            <button class="btn btn-primary ml-2 mr-2" (click)="actualizarContenido()">
                <svg [cIcon]="icons.cilSave" size="xl" title="Guardar" style="color: white !important;"></svg>
            </button>
        </div>
        <div class="col-12">
            <form class="w-100" [formGroup]="form">
                <div class="NgxEditor__Wrapper">
                    <ngx-editor-menu [editor]="editor"> </ngx-editor-menu>
                    <ngx-editor [editor]="editor" [placeholder]="'Type here...'"
                        formControlName="contenido"></ngx-editor>
                </div>
                <div class="row">
                    <div class="col-12">
                        <img width="100%" [src]="imagenContenido" alt="Inspira">
                        <input type="file" name="cambioImagen" id="cambioImagen" (change)="cambioImagen($event)"
                            class="form-control" accept="image/png, image/gif, image/jpeg">
                    </div>
                </div>
                <div class="NgxEditor__Wrapper">
                    <ngx-editor-menu [editor]="editor3"> </ngx-editor-menu>
                    <ngx-editor [editor]="editor3" [placeholder]="'Type here...'"
                        formControlName="contenido3"></ngx-editor>
                </div>
                <div class="row">
                    <div class="col-12">
                        <app-listado-categorias></app-listado-categorias>
                    </div>
                </div>
                <div class="NgxEditor__Wrapper">
                    <ngx-editor-menu [editor]="editor4"> </ngx-editor-menu>
                    <ngx-editor [editor]="editor4" [placeholder]="'Type here...'"
                        formControlName="contenido4"></ngx-editor>
                </div>
            </form>
        </div>
    </div>
    <div class="row" *ngIf="!modoEdicion">
        <div class="col-12" [innerHTML]="html">
        </div>
        <div class="col-12 mt-3">
            <img [src]="imagenContenido" width="100%" alt="categorias">
        </div>
        <div class="col-12 mt-5" [innerHTML]="html3">
        </div>
        <div class="col-12 mt-3">
            <app-listado-categorias></app-listado-categorias>
        </div>
        <div class="col-12 mt-3" [innerHTML]="html4">
        </div>

    </div>
</div>